import { useNavigate } from 'react-router-dom';

// ✅ Constants
const COMPANY_NAME = 'AastroG';
const CONTACT_EMAIL = 'aastrogai@gmail.com';
const HOME_PATH = '/home';

// ✅ Reusable Components
const SectionTitle = ({ children }) => <h2 className="about-section-title">{children}</h2>;
const TextBlock = ({ children }) => <p className="about-text">{children}</p>;
const List = ({ items }) => (
  <ul className="about-list">
    {items.map((item, index) => (
      <li key={index} className="about-list-item">{item}</li>
    ))}
  </ul>
);

function Terms() {
  const navigate = useNavigate();

  return (
    <div className="about-container">
      <h1 className="heading">Terms and Conditions</h1>

      <TextBlock>
        This Disclaimer applies to the website, mobile applications, and services offered by
        <strong> {COMPANY_NAME}</strong> ("Company," "we," "our," or "us"). By accessing or using {COMPANY_NAME}, 
        you acknowledge and agree to the terms set forth below. If you do not agree, please 
        discontinue use of our services immediately.
      </TextBlock>

      <SectionTitle>Informational Purposes Only</SectionTitle>
      <List
        items={[
          'All content, predictions, horoscopes, compatibility reports, and remedies provided through AastroG are for general informational and educational purposes only.',
          'Astrology is a belief-based system and should not be considered an exact science.',
          'The insights generated are intended for self-reflection and guidance, not as absolute or guaranteed outcomes.',
        ]}
      />

      <SectionTitle>No Professional Advice</SectionTitle>
      <TextBlock>
        {COMPANY_NAME} does not provide medical, legal, financial, or psychological advice. Nothing on our platform should be interpreted as professional consultation.
      </TextBlock>
      <List
        items={[
          'For health concerns, please consult a licensed physician.',
          'For legal or financial matters, consult a qualified attorney or advisor.',
          'For mental health issues, seek support from a certified professional.',
          'You agree that you will not rely solely on AastroG for making decisions in these areas.',
        ]}
      />

      <SectionTitle>Accuracy of Information</SectionTitle>
      <List
        items={[
          'Our reports and insights are generated based on the birth data you provide (date, time, place of birth).',
          'Any errors or inaccuracies in your input may impact results.',
          'While our AI models are designed to reduce human error, astrology involves interpretations and probabilities.',
          'We make no warranties or guarantees, express or implied, about the accuracy, reliability, or completeness of the information provided.',
        ]}
      />

      <SectionTitle>No Liability</SectionTitle>
      <TextBlock>
        To the fullest extent permitted by law, {COMPANY_NAME}, its founders, employees, partners, and affiliates shall not be held liable for any direct, indirect, incidental, consequential, or special damages resulting from the use of our services, including but not limited to:
      </TextBlock>
      <List
        items={[
          'Loss of income or business opportunities',
          'Relationship or personal matters',
          'Health-related decisions or outcomes',
        ]}
      />
      <TextBlock>Your use of {COMPANY_NAME} is at your own discretion and risk.</TextBlock>

      <SectionTitle>Remedies and Spiritual Guidance</SectionTitle>
      <List
        items={[
          'Any remedies suggested (including mantras, gemstones, rituals, lifestyle adjustments, or donations) are voluntary and provided as guidance only.',
          'AastroG does not claim, promise, or guarantee any specific results or outcomes from following such remedies.',
        ]}
      />

      <SectionTitle>Privacy of Data</SectionTitle>
      <List
        items={[
          'We respect your privacy.',
          'Personal data, including birth details, are collected solely for the purpose of generating astrological reports.',
          'This data will not be sold or shared with third parties without consent, except as required by law.',
          'Please refer to our Privacy Policy for further details.',
        ]}
      />

      <SectionTitle>External Resources</SectionTitle>
      <List
        items={[
          'Our platform may contain links to third-party websites or resources.',
          'AastroG does not endorse, guarantee, or take responsibility for the content, accuracy, or reliability of such external sites.',
          'Accessing them is at your own risk.',
        ]}
      />

      <SectionTitle>Updates to Disclaimer</SectionTitle>
      <List
        items={[
          'We reserve the right to modify or update this Disclaimer at any time, without prior notice.',
          'The updated version will be effective upon posting.',
          'It is your responsibility to review this Disclaimer periodically.',
        ]}
      />

      <SectionTitle>Age Requirement</SectionTitle>
      <List
        items={[
          'By using AastroG, you confirm that you are at least 18 years old.',
          'Or are accessing the platform under the supervision of a parent or legal guardian.',
        ]}
      />

      <SectionTitle>Consent and Agreement</SectionTitle>
      <TextBlock>By accessing or using {COMPANY_NAME}, you:</TextBlock>
      <List
        items={[
          'Confirm that you have read and understood this Disclaimer.',
          'Acknowledge that astrology is a guidance tool, not an absolute predictor of future events.',
          'Agree to release AastroG and its affiliates from any liability associated with your use of the platform.',
        ]}
      />

      <SectionTitle>Contact Us</SectionTitle>
      <TextBlock>
        For questions or concerns, please contact us at:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`} className="about-link">{CONTACT_EMAIL}</a>
      </TextBlock>

      <hr className="about-divider" />

      <div className="contact-section" style={{ marginTop: '1.5rem' }}>
        <button
          className="contact-btn"
          onClick={() => navigate(HOME_PATH)}
          style={{ width: '100%' }}
        >
          Let's Continue
        </button>
      </div>
    </div>
  );
}

export default Terms;
